module.exports = __webpack_public_path__ + "static/media/Santana.5cbb547e.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Santana.ttf
// module id = 3647
// module chunks = 71